export class StandardBackupSchedules {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "scheduleConfig",
            "baseName": "scheduleConfig",
            "type": "StandardBackupScheduleConfig",
            "format": ""
        },
        {
            "name": "backupRetentionDays",
            "baseName": "backupRetentionDays",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StandardBackupSchedules.attributeTypeMap;
    }
    constructor() {
    }
}
